/**
 * GuildTempl Template
 * @category testApp
 */
class GuildTempl {
	/**
	 * Sub1 Templ
	 * @param  {Object} _d={}
	 */
	static getTempl(_d={}, _profileDomain='', _sandboxDomain='') {
		if(_d.error == 'Forbidden') {
			// console.log('guildTempl.js > _d : ' , _d);
			return GuildTempl.noData();
		} else {
			let list = [];
			list.push(_d.map( item =>{
				return GuildTempl.itemTempl(item, _profileDomain, _sandboxDomain);
			}).join(''));

			return `
        	<ul class="guild-list">${list}</section>
        `;
		}
	}

	static getCounter(_d={}) {
		let counter = 0;
		_d.forEach(function(key, idx) {
			if( _d[idx].playing ) counter++;
		});
		return counter;
	}


	static itemTempl(_d,_profileDomain, _sandboxDomain){
		return `
    	<li class="guild-item">
			<a class="link" href="${_d.characterHome}">
				<img class="thumb" src="${_profileDomain}${_d.profileImageUrl}"> 
				<span class="character">${_d.name}</span>
				<span class="location"> ${_d.playing ? _d.geoZoneName : ''}</span> ${_d.playing ? `<i class="is-online"></i>` : ``}
			</a>
		</li>`;
	}
//${_d.own?``:`<button class="btn-gift flag" data-charname="${_d.name}"><span class="flag-gift">선물</span></button>`} 선물하기 삭제
	static noData(state) {

		// console.log(state, stateMessage[state]);
		// 기획에서 케이스 별로 동일한 메시지를 보여주기로 함
		let stateMessage = {
			'stateNochar':'<p>대협! 홍문파 동문을 만나보지 않았군요.<br> 게임에 접속해서 캐릭터를 먼저 생성해주세요.</p><a class="link" href="/world/guildpr">문파 홍보 보기</a>',
			'stateBoss':'<p>대협! 대표캐릭터를 설정해주세요.<br> 가입한 문파의 세부 정보를 확인할 수 있어요.</p><a class="link" href="/world/guildpr">문파 홍보 보기</a>',
			'stateNoname':'<p>대협! 아직 입문한 문파가 없으시네요.<br> 문파에 가입, 다양한 콘텐츠를 즐겨보세요.</p><a class="link" href="/world/guildpr">문파 홍보 보기</a>',
			'stateBlock':'<p>대협! 아직 입문한 문파가 없으시네요.<br> 문파에 가입, 다양한 콘텐츠를 즐겨보세요.</p><a class="link" href="/world/guildpr">문파 홍보 보기</a>',
			'Nojoin':'<p>대협! 아직 입문한 문파가 없으시네요.<br> 문파에 가입, 다양한 콘텐츠를 즐겨보세요.</p><a class="link" href="/world/guildpr">문파 홍보 보기</a>'
		};

		return `
			<div class="nodata">${stateMessage[state]}</div>
		`;
	}


} // end of class

export default GuildTempl;